import React from "react";
import { ExternalDocument, Locale } from "../../core/api/model";
import { DashboardDocumentsList } from "../DashboardDocumentsList";
import { DashboardPanel, DashboardPanelItem } from "../DashboardPanel";
import { useIntl } from "react-intl";

export interface DashboardDocumentsPanelProps {
  locale: Locale;
  documents: ExternalDocument[];  
}

export const DashboardDocumentsPanel = (props: DashboardDocumentsPanelProps) => {
  const intl = useIntl();

  return (
    <DashboardPanel
      title={intl.formatMessage({id: 'DashboardDocumentsTitle'})}
    >
      <DashboardPanelItem tabtitle=''>
        <DashboardDocumentsList documents={props.documents.slice().sort((a, b) => (a.accessDate > b.accessDate ? -1 : 1))} />
      </DashboardPanelItem>
    </DashboardPanel>
  )
};
